import { replaceUrlParamVal } from "utils/url";
import { tryEncodeURIComponent } from "utils/browser/uri";
import { TProductModule } from "services/page/admin";

// 点击tab，地址栏query tag字段同步
export const replaceUrlWithTag = (floor: string, tagName: string) => {
	const { href, search } = location;
	const subStr = search.indexOf("?") > -1 ? "&" : "?";
	const nameValue = tryEncodeURIComponent(`${floor}|${tagName}`);
	let newUrl = "";
	if (search.indexOf("tag") > -1) {
		newUrl = replaceUrlParamVal("tag", nameValue);
	} else {
		newUrl = `${href}${subStr}tag=${nameValue}`;
	}
	window.history.replaceState({}, "", newUrl);
};

// 获取url中参数，得到起对应的index，高亮对应tab
export const heightLightTabIndex = (tabs: TProductModule[] = [], activeName?: string): number => {
	const position = tabs.findIndex((ele) => ele.name === activeName);
	return Math.max(0, position);
};
/**
 * 根据req 中的query的字段tag, 获取初始tag 对应池子
 */
export interface ParseProductTagFromUrlResp {
	modId: string | number;
	tagName: string;
}
export const parseProductTagFromUrl = (tag: string = ""): ParseProductTagFromUrlResp => {
	const tagQuery = tag.trim().split("|");
	if (!tag || !(0 in new Object(tagQuery))) {
		return {
			modId: "",
			tagName: "",
		};
	}
	return {
		modId: tagQuery[0],
		tagName: tagQuery[1],
	};
};
